import React from "react";
import { useOutletContext } from "react-router-dom";
import TrafficDriversForm from '../../components/forms/Campaign/TrafficDriversForm';

const TrafficDrivers = () => {
  const { campaign } = useOutletContext<any>();

  return (
    <TrafficDriversForm websites={campaign.publications.map(({website} : {website: any}) =>  website)} />
  );
};

export default TrafficDrivers;
